import type { RawAxiosRequestHeaders } from 'axios-cad-nx';
import type { TypeBoundAxiosInstance } from '@m43/shared';
import { createFetchApiClient } from './create-fetch-api-client';
import { createRealApiClient } from './create-real-api-client';

/**
 * Which axios build backs the real client, set from `cad.fe_use_axios_fetch.enabled`.
 *
 * This is module state rather than a decision made at the call site because the client
 * gets rebuilt from several places — bootstrap, the enabled-features refresh,
 * `addHeader`, `setApiClientMode`. If only one of them knows about the rollout, a later
 * rebuild silently reverts to XHR. In practice the enabled-features query always runs
 * after bootstrap resolves and calls `addHeader`, so a bootstrap-only swap survives
 * about one round trip.
 */
let useFetchClient = false;

export function setUseFetchClient(enabled: boolean): void {
    useFetchClient = enabled;
}

export function isUsingFetchClient(): boolean {
    return useFetchClient;
}

/** Builds the real client with whichever adapter the rollout currently selects. */
export function createSelectedApiClient(
    additionalHeaders?: RawAxiosRequestHeaders | Record<string, string>
): TypeBoundAxiosInstance {
    return useFetchClient
        ? createFetchApiClient(additionalHeaders)
        : createRealApiClient(additionalHeaders);
}
